export default {
  state: {
    isActive: null,
    isRoute: null,
    selectedProduct: 4,
    queue: [],
  },
  getters: {
    selectedProduct(state) {
      return state.selectedProduct;
    },
    isRoute(state) {
      return state.isRoute;
    },
    isActive(state) {
      return state.isActive;
    },
  },
  mutations: {
    SET_ACTIVE(state, active) {
      state.isActive = active;
    },
    SET_ROUTE(state, route) {
      state.isRoute = route;
    },
    SET_SELECTED_PRODUCT(state, product) {
      state.selectedProduct = product;
    },
  },
  actions: {
  },
};
